import { createAsyncThunk } from "@reduxjs/toolkit";

import API, { showNetworkErrorToast } from "Utils/api";

export const fetchGetCompanies = createAsyncThunk(
  "companies/fetchGetCompanies",
  async () => {
    try {
      const response = await API.get("companies/");

      return response.data.results;
    } catch (error) {
      showNetworkErrorToast(error);
      return Promise.reject();
    }
  }
);
